module.exports = {
    methods: {
        t(key, replace = {}) {
            let translation = this.$page.props.language[key]
                ? this.$page.props.language[key]
                : key

            Object.keys(replace).forEach(function (key) {
                translation = translation.replaceAll(':' + key, replace[key])
            });

            return translation
        },
        uuid(e) {
            if (e.uid) return e.uid;

            const key = Math.random()
                .toString(16)
                .slice(2);

            this.$set(e, "uid", key);

            return e.uid;
        },
        archive(entity, routeName, message = 'swal_archive_default', messageKey = 'name') {
            this.$swal({
                title: this.t(message, {name: entity[messageKey]}),
                icon: 'error',
                showCancelButton: true,
                confirmButtonText: this.t('swal_btn_archive'),
                confirmButtonColor: '#d33',
                cancelButtonText: this.t('btn_cancel'),
                showCloseButton: true
            }).then((result) => {
                if (!result.value) return;
                this.$inertia.put(this.route(routeName, entity.id), {}, {
                    preserveScroll: true
                })
            })
        },
        rentalFeeFormat (price) {
            return '• ' + this.t(price.extra_unit_name) + ': ' + this.$options.filters.price(price.extra_unit_price);
        },
        formatUnitPrice(num) {
            return +Math.round((parseFloat(num) + Number.EPSILON) * 100) / 100
        },
        backLink() {
            window.history.back();
        }
    },
    filters: {
        orDash: function (value, placeholder = '-') {
            return value ?? placeholder
        },
        price: function (value) {
            if (typeof value !== "number") {
                return value;
            }
            const formatter = new Intl.NumberFormat('de-DE', {
                //style: 'currency',
                //currency: 'HUF',
                minimumIntegerDigits: 1,
                minimumFractionDigits: 0
            });

            return formatter.format(value) + String.fromCharCode(160) + 'Ft';
        },
        truncated: function (str, num = 30) {
            if (typeof str !== 'string' || str.length <= num) {
                return str
            }
            return str.slice(0, num) + '...'
        }
    },
}
